import LegalPageLayout from '@/components/LegalPageLayout';

const Section = ({ n, title, children, highlight = false }) => (
  <section
    className={`space-y-3 ${highlight ? 'rounded-2xl border border-amber-500/30 bg-amber-500/5 p-5' : ''}`}
    data-testid={`terms-section-${n}`}
  >
    <h2 className={`text-2xl font-bold ${highlight ? 'text-amber-200' : 'text-white'}`} style={{ fontFamily: 'Outfit' }}>
      {n}. {title}
    </h2>
    <div className="space-y-3">{children}</div>
  </section>
);

const List = ({ items }) => (
  <ul className="list-disc pl-6 space-y-1.5 text-zinc-300">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);

export default function Terms() {
  return (
    <LegalPageLayout title="Terms & Conditions" lastUpdated="28-04-2026" testId="terms-page">
      <Section n={1} title="Introduction">
        <p>These Terms govern use of Law Agency 360 by:</p>
        <div className="not-prose rounded-xl border border-white/10 bg-white/[0.03] p-4 text-sm">
          <div className="font-semibold text-white">Perfect Multimedia Global Limited</div>
          <div>51 Bracken Road, Sandyford</div>
          <div>Dublin 18, D18 CV48</div>
          <div>Company No.: 687854</div>
          <div>VAT Number: IE3761530HH</div>
        </div>
      </Section>

      <Section n={2} title="Services">
        <p>We provide digital marketing, website creation, and legal translation services.</p>
      </Section>

      <Section n={3} title="Accounts">
        <p>You must provide accurate information and maintain account security.</p>
      </Section>

      <Section n={4} title="Subscription & Billing">
        <List items={['Monthly or yearly plans', 'Payments via Stripe', 'Accurate billing required']} />
      </Section>

      <Section n={5} title="No Refund Policy" highlight>
        <p className="font-semibold text-amber-100">All payments are strictly non-refundable.</p>
        <p>No refunds will be issued for:</p>
        <List items={['Partial usage', 'Unused services', 'Early cancellation']} />
      </Section>

      <Section n={6} title="Cancellation">
        <p>You may cancel anytime.</p>
        <List items={['Access continues until end of paid billing cycle', 'No further charges after cancellation']} />
      </Section>

      <Section n={7} title="Service Availability">
        <p>We do not guarantee uninterrupted service.</p>
      </Section>

      <Section n={8} title="Client Responsibilities">
        <p>You must provide accurate info and comply with laws.</p>
      </Section>

      <Section n={9} title="Intellectual Property">
        <p>All platform content belongs to Perfect Multimedia Global Limited.</p>
      </Section>

      <Section n={10} title="Confidentiality">
        <p>Client data and documents are treated as confidential.</p>
      </Section>

      <Section n={11} title="Third-Party Services">
        <p>Includes Stripe, Google services, etc.</p>
      </Section>

      <Section n={12} title="Limitation of Liability">
        <p>We do not guarantee results or outcomes.</p>
      </Section>

      <Section n={13} title="Termination">
        <p>We may suspend accounts for violations or non-payment.</p>
      </Section>

      <Section n={14} title="Changes">
        <p>Terms may be updated anytime.</p>
      </Section>

      <Section n={15} title="Governing Law">
        <p>These Terms are governed by Irish law.</p>
      </Section>

      <Section n={16} title="Contact">
        <div className="not-prose rounded-xl border border-white/10 bg-white/[0.03] p-4 text-sm">
          <div className="font-semibold text-white">Perfect Multimedia Global Limited</div>
          <div>51 Bracken Road, Sandyford</div>
          <div>Dublin 18, D18 CV48</div>
          <a className="text-violet-300 hover:underline" href="mailto:lawagency360@gmail.com">lawagency360@gmail.com</a>
        </div>
      </Section>
    </LegalPageLayout>
  );
}
